import { Box, Flex, HStack, Table, TableContainer, Tbody, Text, Th, Thead, Tr, useDisclosure } from '@chakra-ui/react'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { AiOutlinePlus } from 'react-icons/ai'
import CreateSRAModal from '../Components/CreateSRAModal'
import MoreSRA from '../Components/MoreSRA'
import Pagination from '../Components/Pagination'
import PendingIQA from '../Components/PendingIQA'
import Preloader from '../Components/Preloader'
import TableRow from '../Components/TableRow'
import MainLayout from '../Layouts/Index'
import { GetAllPendingSRA, GetAllSRA, GetPendingScn } from '../Utils/ApiCalls'
import Seo from '../Utils/Seo'
import { configuration } from '../Utils/config'

export default function InspectStoreCreditNote() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [SraID, setSraID] = useState("");
  const [Qtyreturned, setQtyreturned] = useState("");

  const [Data, setData] = useState([]);

  const [CurrentPage, setCurrentPage] = useState(1);
  const [PostperPage, setPostperPage] = useState(configuration.sizeperpage);

  const [PreLoader, setPreLoader] = useState(true);


  

  //get current post

  const indexOfLastSra = CurrentPage * PostperPage;
  const indexOfFirstSra = indexOfLastSra - PostperPage;
  const currentSCN = Data.slice(indexOfFirstSra, indexOfLastSra);
  //change page 
  const paginate = (pageNumber) => {
      setCurrentPage(pageNumber)
  }



  
 

  const AllPendingScn = async () => {
    let result = await GetPendingScn()

    console.log("pending scn", result);

    if (result.status == true) {
        setData(result.queryresult.scndetails
          )

          setPreLoader(false)
    }
}

const Inspectscn = (id,qty)=>{
    onOpen()
    setSraID(id)
    setQtyreturned(qty)
}

useEffect(() => {
  AllPendingScn()

}, [isOpen]);
  return (
   <MainLayout>
      {
                PreLoader && (

                    <Preloader/>
                )
            }
    <Seo title="Quality Inspection" description='IMS Quality Inspection '/> 

  <Flex justifyContent={"flex-end"} flexWrap="wrap" fontWeight={"500"}>


<Text textTransform="Capitalize" >Total Pending I&QA- {Data?.length}</Text>
  </Flex>


  <Box display={"block"} alignItems="flex-start" w={"100%"} height="70vh" minH={"70vh"} overflow="auto" _hover={{overflow: "auto"}} bg="blue.blue200" mt="32px" rounded={"8px"}>
            
            <TableContainer w={"100%"} mt="32px" overflowX="auto" color="#fff"
     
            >
              <Table variant='simple' size='sm' overflowX="auto" >
              <Thead>
                  <Tr>
                    <Th color="#fff">S/N</Th>
                    <Th color="#fff">Product name</Th>
                    <Th color="#fff">Price</Th>
                    <Th color="#fff">Qty Returned</Th>
                    <Th color="#fff">Returnee Dept</Th>
                    <Th color="#fff">Return By</Th> 
                    <Th color="#fff">Action</Th> 
                    
                  </Tr>
                </Thead>
                <Tbody>
              {
                currentSCN.map((item,i)=>(
                  <TableRow
                    key={i}
                    sn={i+1}
                    type="pendingScn"
                    productName={item.shelfid.productname}
                    price={item.price}
                    qty={item.qtyreturned}
                    dept={item.returneedepartment}
                    returnby={item.returnby}
                   onClick={()=>Inspectscn(item._id,item.qtyreturned)}
                  />
                ))
              }
                </Tbody>
      
              </Table>
            </TableContainer>

            <Pagination postPerpage={PostperPage} currentPage={CurrentPage} totalPosts={Data.length} paginate={paginate} />


            </Box>

<PendingIQA isOpen={isOpen} onClose={onClose} id={SraID} qty={Qtyreturned} state="certifyScn"/>
   </MainLayout>
  )
}

